<template>
  <v-dialog :model-value="required" persistent scrollable max-width="800">
    <v-card>
      <v-card-title>Review and accept the terms</v-card-title>
      <v-card-text>
        <v-alert v-if="store.termsError" type="error">{{ store.termsError }}</v-alert>
        <template v-else-if="store.currentTerms">
          <p class="mb-4">Effective: {{ effectiveDateLabel }}</p>
          <TermsContent :terms="store.currentTerms" />
          <v-checkbox v-model="agreed" label="I have read and agree to these terms." />
        </template>
        <v-alert v-if="error" type="error">{{ error }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn data-mp-name="terms-update.retry" v-if="store.termsError" :loading="store.termsLoading" @click="retry">Retry</v-btn>
        <v-btn data-mp-name="terms-update.accept" v-else color="primary" variant="flat" :disabled="!agreed || store.termsLoading" :loading="saving" @click="accept">I Agree</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { computed, ref, watch } from 'vue'
import { DateTime } from 'luxon'
import { useKinectinStore } from '@/store/kinectin.js'
import TermsContent from './TermsContent.vue'
defineProps({ required: Boolean })
const store = useKinectinStore()
const effectiveDateLabel = computed(() => {
  const effectiveAt = store.currentTerms?.effectiveAt
  return effectiveAt ? DateTime.fromISO(effectiveAt).toLocaleString(DateTime.DATETIME_FULL) : ''
})
const agreed = ref(false)
const saving = ref(false)
const error = ref('')
watch(() => store.currentTerms, () => { agreed.value = false })
async function retry() {
  try { await store.refreshTerms({ force: true }) } catch { /* Store displays the error. */ }
}
async function accept() {
  saving.value = true
  error.value = ''
  try { await store.acceptCurrentTerms() } catch { error.value = 'Unable to save acceptance. Review the current terms and try again.' }
  finally { saving.value = false }
}
</script>
